module.exports = __webpack_public_path__ + "static/img/dorm-active.b57f02e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/dorm-active.png
// module id = ePod
// module chunks = 26